import React from 'react'
import { Box, Typography } from '@mui/material'
import { Close } from '@mui/icons-material'
import theme from '../theme'

interface FilterPillProps {
  label: string
  value?: string
  onRemove?: () => void
  onClick?: () => void
  showCloseIcon?: boolean
}

const FilterPill: React.FC<FilterPillProps> = ({
  label,
  value,
  onRemove,
  onClick,
  showCloseIcon = true,
}) => {
  const isClickable = Boolean(onClick)
  const hasRemoveAction = Boolean(onRemove) && showCloseIcon

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '2px 8px',
        borderRadius: '9999px',
        border: '1px solid',
        backgroundColor: theme.palette['base-white'],
        color: theme.palette['sage-500'],
        fontSize: theme.typography['body-10'].fontSize,
        lineHeight: '16px',
        cursor: isClickable ? 'pointer' : 'default',
        '&:hover': isClickable ? {
          backgroundColor: theme.palette['sage-50']
        } : {}
      }}
      onClick={onClick}
    >
      <Typography variant='body-10' sx={{ marginRight: value ? '6px' : '0', color: theme.palette['sage-500'] }}>
        {label}{value ? ':' : ''}
      </Typography>
      {value && (
        <Typography variant='body-10' sx={{ marginRight: hasRemoveAction ? '6px' : '0' }}>
          {value}
        </Typography>
      )}
      {hasRemoveAction && (
        <Close
          aria-label={`Clear ${label.toLowerCase()} ${value || ''}`}
          onClick={(e) => {
            e.stopPropagation()
            onRemove?.()
          }}
          sx={{
            cursor: 'pointer',
            fontSize: '16px',
            color: theme.palette['sage-500']
          }}
        />
      )}
    </Box>
  )
}

export default FilterPill
